export default {
  /**
   * Return substitution text based on detail.replaceable
   *
   * @param {Object} detail
   * @returns {String}
   */
  getSubstitutionText (detail) {
    switch (detail.replaceable) {
      case 1:
        return this.$t('order.replaceable.delete_from_order')

      case 2:
        return this.$t('order.replaceable.replace_with_similar')

      case 3:
        return this.$t('order.replaceable.call_for_alternative')

      default:
        return ''
    }
  }
}
